<script>
    import {mapActions,mapState,mapGetters} from "vuex";


    export default {
        name: "CourseOverviewSection",
        data () {
            return {
                givesContextToChildren: true,
                sectionType: 'course-overview-section'
            }
        },
        computed: {
            ...mapState('products', [
                'courses',
                'fetchingCourseContents',
            ]),
            ...mapState([
                'serverImg',
            ]),
            myCourseData () {
                let courseFound = {};

                this.courses.map(course => {
                    if (course.titleId === this.selectedCourseTitleId) {
                        courseFound = course;
                    }
                })

                return courseFound;
            },
            selectedCourseTitleId () {
                if (this.sectionData.selectedCourseTitleId) {
                    return this.sectionData.selectedCourseTitleId
                }

                if (this.isPageContext('course') && this.pageContext.params && this.courses.filter( course => course.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
        },
        methods: {
            ...mapActions('products', [
                'getCourseContents'
            ]),
            getSelectedCourse () {
                return this.selectedCourseTitleId;
            },
            getDataForContext () {
                // todo change the following line to something that fetches the currentCourse dynamically
                const currentCourseTitleId = this.getSelectedCourse();

                //make sure its not being fetched and also make sure to has been fetched with author getParam so we can have sections and other verbosity data
                if (currentCourseTitleId && this.fetchingCourseContents.indexOf(currentCourseTitleId) === -1 && ( !this.myCourseData.titleId || ( this.myCourseData && typeof this.myCourseData.sections === "undefined"))) {
                   return this.getCourseContents({courseId: currentCourseTitleId, getParams: "author"}).then( (courseData) => {
                       return this.editCourseData(courseData);
                   });
                }

                return new Promise( (resolve,reject) => {
                    resolve(this.editCourseData(this.myCourseData));
                })

            },
            editCourseData (courseData) {
                if (!courseData.titleId) {
                    return courseData;
                }

                let clonedData = copyJson(courseData);

                if (typeof clonedData.courseImage.name !== 'undefined' && clonedData.courseImage.name) {
                    const baseUrlWithoutEndingSlash = this.serverImg.slice(0, -1);
                    clonedData.courseImageUrl = baseUrlWithoutEndingSlash + clonedData.courseImage.name;
                } else {
                    clonedData.courseImageUrl = null;
                }

                return clonedData;
            }
        }
    }
</script>
